module.exports = __webpack_public_path__ + "img/astronomers.9a437d56.jpg";